__turbopack_context__.v({
  "container": "premium-course-notice-module-scss-module__t34cCq__container",
});
